<template>
    <modal
        v-if="show"
        :form="form"
        :type="typeModal"
        :title="title"
        :submit-text="textButton"
        :submit-disabled="disabled"
        @submit="submit"
        @closed="closed"
    >
        <template v-if="typeSegment === 'create' || typeSegment === 'update'">
            <template>
                <form-input
                    v-model="form.name"
                    :form="form"
                    label="Segment Name"
                    :error="form.errors.get('name')"
                />
            </template>
        </template>
        <template v-else>
            Are you sure you want to delete the “{{ chooseFilter.name }}” segment?
        </template>
    </modal>
</template>

<script>
import Form from 'core/Form';

export default {
    emits: ['closed', 'handleSaveSegment', 'handleUpdateSegment', 'handleDeleteSegment'],
    
    props: {
        show: { type: Boolean, default: false },
        typeSegment: { type: String, default: '' },
        chooseFilter: { type: Object },
    },

    data() {
        return {
            form: new Form({
                name: '',
            }),
        };
    },

    computed: {
        typeModal() {
            return this.typeSegment === 'delete' ? 'is-danger' : 'is-primary';
        },

        disabled() {
            if (this.typeSegment === 'delete') {
                return false;
            }

            return this.form.busy || !this.form.name.length;
        },

        title() {
            if (this.typeSegment === 'create') {
                return 'Save Segment';
            }

            if (this.typeSegment === 'update') {
                return 'Update Segment';
            }

            if (this.typeSegment === 'delete') {
                return 'Delete Segment';
            }

            return '';
        },

        textButton() {
            if (this.typeSegment === 'create') {
                return 'Save';
            }

            if (this.typeSegment === 'update') {
                return 'Update';
            }

            if (this.typeSegment === 'delete') {
                return 'Delete';
            }

            return '';
        },
    },

    watch: {
        show(status) {
            if (status) {
                if (this.chooseFilter) {
                    this.form.name = this.chooseFilter.name;
                } else {
                    this.form.name = '';
                }
            }
        },
    },

    methods: {
        closed() {
            this.$emit('closed', false);
        },

        async submit() {
            if (this.typeSegment === 'create') {
                await this.$emit('handleSaveSegment', this.form);
            }

            if (this.typeSegment === 'update') {
                await this.$emit('handleUpdateSegment', this.form);
            }

            if (this.typeSegment === 'delete') {
                await this.$emit('handleDeleteSegment', this.form);
            }
        },
    },
};
</script>
